export default __webpack_public_path__ + "static/media/bg-pattern-ico.3efe91cb.png";